import {
  Box,
  Button,
  Typography
} from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  resetConnectBusinessState
} from "../redux/features/connectBusinessStateSlice";

export const ConnectBusinessExpandNoEmployees = ({ message = "We couldn't find any cleaner in your area"}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const handleBackHomeClick = () => {
      dispatch( resetConnectBusinessState ())
      navigate('/business'); // Esto redirige al usuario a la ruta de inicio
    };
  
  
  return (
<Box
      sx={{
        bgcolor: 'rgba(35, 48, 68, 1)',
        borderRadius: 2,
        p: 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        minHeight: '200px', // Ajustar según sea necesario
        width: '100%',
      }}
    >
      <Typography variant="h4" component="h1" gutterBottom>
        WE ARE SORRY
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        {message}
      </Typography>
      <Button
        variant="contained"
        // color="secondary"
        sx={{ mt: 2, borderRadius: 20, px: 3 }} // px es para el padding horizontal
        onClick={handleBackHomeClick}
      >
        BACK HOME
      </Button>
    </Box>
  );
};